document.addEventListener('DOMContentLoaded', function () {
  /* ugc carousels */
  document.querySelectorAll('[data-essanes-ugc]').forEach(function(el){
    var t=el.querySelector('.ugc__track'),d=el.querySelectorAll('.ugc__dot'),n=t.children.length,i=0;if(!n)return;
    function go(k){i=(k+n)%n;t.style.transform='translateX(-'+(i*100)+'%)';d.forEach(function(x,j){x.classList.toggle('on',j===i);});}
    d.forEach(function(x,j){x.onclick=function(){go(j);};});setInterval(function(){go(i+1);},2600);
  });

  /* bundle add-to-cart */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-essanes-bundle]');if(!b)return;e.preventDefault();
    var ids=b.getAttribute('data-ids').split(',').filter(Boolean);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:ids.map(function(id){return{id:Number(id),quantity:1};})})})
      .then(function(){window.location='/cart';}).catch(function(){alert('Could not add bundle, please try again.');});
  });

  /* scroll reveal */
  document.documentElement.classList.add('js-reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.1});
    document.querySelectorAll('.essanes').forEach(function(el){io.observe(el);});
  }else{document.querySelectorAll('.essanes').forEach(function(el){el.classList.add('is-in');});}

  /* custom cursor (desktop only) */
  if(matchMedia('(hover:hover) and (pointer:fine)').matches && innerWidth>1024){
    var r=document.createElement('div');r.className='essanes-cursor';
    var dt=document.createElement('div');dt.className='essanes-cursor-dot';
    document.body.appendChild(r);document.body.appendChild(dt)
    var mx=innerWidth/2,my=innerHeight/2,rx=mx,ry=my;
    addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;dt.style.left=mx+'px';dt.style.top=my+'px';});
    (function lp(){rx+=(mx-rx)*.18;ry+=(my-ry)*.18;r.style.left=rx+'px';r.style.top=ry+'px';requestAnimationFrame(lp);})();
    var s='a,button,.pc,.size,.chip,.ctile,.ugc__dot,[data-essanes-bundle]';
    document.addEventListener('mouseover',function(e){if(e.target.closest(s))r.classList.add('is-big');});
    document.addEventListener('mouseout',function(e){if(e.target.closest(s))r.classList.remove('is-big');});
  }
});